<template>
  <div
    id="freedom"
    :style="{ backgroundColor: country === 'hongkong' ? '#ffffff' : '' }"
  >
    <div class="inner">
      <div class="top">
        <div class="top_box_l">
          <div class="top_title">{{ $t("home_freedom_title") }}</div>
          <div
            class="top_desc_title"
            :style="{
              marginTop: ['zh_CN', 'zh_HK'].includes(lang)
                ? '0px'
                : '2.60417vw',
            }"
          >
            {{ $t("home_freedom_download_title") }}
          </div>
          <div class="top_desc">
            {{ $t("home_freedom_download_desc") }}
          </div>
          <div class="top_img">
            <div class="top_img_l">
              <img
                :src="
                  country === 'hongkong'
                    ? require('@/assets/Keeta2/keetapowerbank.png')
                    : require('@/assets/Keeta2/erweima.png')
                "
                alt=""
              />
            </div>
            <div class="top_img_r">
              <img src="@/assets/Keeta2/image@2x-2.png" alt="" />
            </div>
          </div>
        </div>
        <div class="top_box_r">
          <img v-if="country === 'uk'" src="@/assets/Keeta2/105931@2x.png" alt="" />
          <img v-else src="@/assets/Keeta2/phone-hk@2x.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCountryByDomain } from "@/common/config";
export default {
  name: "FreedomView",
  data() {
    return {};
  },
  methods: {},
  computed: {
    country() {
      return getCountryByDomain(window.location.hostname);
    },
    lang() {
      return this.$i18n.locale;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/_variables.scss";
#freedom {
  min-width: $min-width;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 50px 0;
  background-color: #f7f8f9;
  .inner {
    width: 1200px;
  }

  .top {
    display: flex;
    .top_box_l {
      color: #111111;
      width: 701px;
      .top_title {
        width: 701px;
        height: 100px;
        font-weight: 900;
        font-size: 1.3rem;
        line-height: 50px;
        font-family: $title-font;
      }
      .top_desc_title {
        margin-top: 50px;
        margin-bottom: 15px;
        font-weight: 700;
        font-size: $font-size-small;
        font-family: $content-font;
      }
      .top_desc {
        font-weight: 400;
        font-size: $font-size-mini;
        color: #999999;
        line-height: 28px;
        font-family: $content-font;
      }
      .top_img {
        display: flex;
        margin-top: 82px;
        .top_img_l img {
          width: 119px;
          height: 120px;
        }
        .top_img_r {
          margin-top: 18.5px;
          margin-left: 25px;
          img {
            width: 120px;
            height: 83px;
          }
        }
      }
    }
    .top_box_r {
      margin-left: 50px;
      img {
        width: 480px;
      }
    }
  }
}
</style>